// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.separator {
  height: 15px;
}

.text-no-user::ng-deep {
  margin-top: 26px;
}

.div-see {
  overflow-y: auto;
}
.div-see .card {
  width: 100%;
  margin: 10px auto;
}
.div-see .card .id {
  color: rgb(173, 173, 173);
  font-style: italic;
}

::ng-deep .mat-mdc-text-field-wrapper {
  background-color: white !important;
}`, "",{"version":3,"sources":["webpack://./src/app/+home/shared/components/dialog-lookup-users-groups/dialog-lookup-users-groups.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;;AACA;EACE,gBAAA;AAEF;;AAKA;EACE,gBAAA;AAFF;AAIE;EACE,WAAA;EACA,iBAAA;AAFJ;AAII;EACE,yBAAA;EACA,kBAAA;AAFN;;AAMA;EACE,kCAAA;AAHF","sourcesContent":[".separator {\r\n  height: 15px;\r\n}\r\n.text-no-user::ng-deep{\r\n  margin-top: 26px;\r\n}\r\n\r\n// .bloc-users::ng-deep{\r\n//   margin-top:14px\r\n// }\r\n\r\n.div-see {\r\n  overflow-y: auto;\r\n\r\n  .card {\r\n    width: 100%;\r\n    margin: 10px auto;\r\n\r\n    .id {\r\n      color: rgb(173, 173, 173);\r\n      font-style: italic;\r\n    }\r\n  }\r\n}\r\n::ng-deep .mat-mdc-text-field-wrapper {\r\n  background-color: white !important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
